import { createStreamRequest } from '@/tool/request/streamRequest'
import { httpGet, httpPost } from '@/tool/request/index';
const streamRequest = createStreamRequest();
const streamRequest_audio_to_text = createStreamRequest({ baseURL: 'http://kfe.luyuaqua.com' });
type requestParams = {
  query: string
  inputs?: object
  user?: string
  response_mode: 'streaming' | 'blocking'
  conversation_id: string | null
}

// 发送AI对话
export const sendAiDialogue = (url: string, data: requestParams, callback: (_error: any, _success: any) => void) => {
  let _error = null;
  streamRequest.request({
    url,
    method: "POST",
    data: {
      ...data,
      response_mode: "streaming",
      inputs: data.inputs ?? {}
    },
    onMessage: (data: any) => {
      callback(_error, data)
    },
    onError: (err: any) => {
      console.log('_error', _error);
      _error = err;
      callback?.(_error, null)
    },

  });
  return streamRequest
}

// 停止响应
export const stopResponding = async (taskId: string, data: any) => {
  return await httpPost<API.RootResponse<any>>(`/v1/chat-messages/${taskId}/stop`)({
    data: {
      ...data
    }
  });
}

// 发送水印数据
export const sendSaveRecord = async (data: any) => {
  return await httpPost<API.RootResponse<any>>(`/chat/media/save`)({
    data: data
  });
};

// 获取历史会话记录列表
export const getConversationsList = async (userId: string) => {
  return await httpGet<API.RootResponse<any>>(`/v1/conversations?user=${userId}`)();

};

// 下载图片
export const downloadImage = async (data: any) => {
  return await httpPost('/api/screenshot', 'http://129.204.149.109:5555')({
    header: {
      'content-type': 'application/json'
    },
    data: {
      ...data
    }
  })
}

// 发送录音转换文字到另外一个AI (成功负责)
export function healderSendAudioMessage(url: string, data: { query: string }, callback: (_error: any, _success: any) => void) {
  let _error = null;
  streamRequest_audio_to_text.request({
    url: url,
    method: "POST",
    data: data,
    onMessage: (data: any) => {
      callback(_error, data)
    },
    onError: (err: any) => {
      console.log('_error', _error);
      _error = err;
      callback?.(_error, null)
    },

  });
  console.log('查看返回值', streamRequest_audio_to_text);
  return streamRequest_audio_to_text
}


type RecordingAuth = {
  [x: string]: any;
  url: string,
  nonceStr: string,
  timestamp: string | number,
  isTest: boolean
}
// 获取飞书录音授权
export async function getFeiShuAudioRecordingAuth(params: RecordingAuth) {
  console.log('参数··', params.nonceStr);
  return await httpGet<API.RootResponse<any>>(`/getSignature`, 'http://129.204.149.109:9010')({
    params: {
      url: encodeURIComponent(params.url),
      noncestr: params.nonceStr,
      timestamp: params.timestamp,
      type: params.type,
      isTest: params.isTest,
    }
  });
};












